import {inject, Injectable} from '@angular/core';

import {Observable} from 'rxjs';

import * as PL2 from '@common/utils/dist/models/models-pl2.js';
import {QuillToMarkdownAdapter} from '@common/utils/dist/adapters/quill-to-markdown/quill-to-markdown.adapter.js';

import {Action} from '@actions/action';
import {
  CreateSectionAction,
  SectionTarget,
} from '@actions/create-section.action';

export interface AddTextSectionInput {
  title: string;
  markdown: string;
}

/** Adds a text section proposed by the lesson chat to the end of the current lesson. */
@Injectable({providedIn: 'root'})
export class AddTextSectionToLessonAction implements Action<
  AddTextSectionInput,
  PL2.AnySectionEntry
> {
  private _createSectionAction = inject(CreateSectionAction);
  private _quillAdapter = new QuillToMarkdownAdapter();

  execute(
    input: AddTextSectionInput,
    target?: SectionTarget,
  ): Observable<PL2.AnySectionEntry> {
    return this._createSectionAction.execute({
      partialEntry: {
        n: input.title,
        con: this._quillAdapter.adaptFrom(input.markdown),
      } as Partial<PL2.TextSectionEntry>,
      entryType: PL2.EntryType.TextSection,
      index: Number.MAX_SAFE_INTEGER,
      scope: PL2.SectionScope.Group,
      target,
    });
  }
}
